import React from 'react';
import SectionTabs from '../../components/SectionTabs';
import ManagementAnalytics from './Analytics';
import ManagementActivity from './Activity';
import ManagementAppVersions from './AppVersions';

/**
 * Analytics : deux lectures de la même période.
 *  - « Locations » (par défaut) : ce que deviennent les demandes, ce qui marche.
 *  - « App » (`?vue=app`) : qui utilise l'app, sur quel téléphone, avec
 *    quelle version, et quels écrans (mesure maison, API migration 082).
 *  - « Versions » (`?vue=versions`) : version minimale et dernière version
 *    de l'app par plateforme (API migration 088).
 */
const AnalyticsHub = () => (
  <SectionTabs
    ariaLabel="Analytics"
    views={[
      { id: 'locations', label: 'Locations', render: () => <ManagementAnalytics /> },
      { id: 'app', label: 'App', render: () => <ManagementActivity /> },
      { id: 'versions', label: 'Versions', render: () => <ManagementAppVersions /> }
    ]}
  />
);

export default AnalyticsHub;
